import { Modal } from 'antd';
import { Button, Input, Space } from 'antd';

interface INewTemplateModalProps {
    newTemplateModalVisible: boolean;
    setNewTemplateModalVisible: (visible: boolean) => void;
    newTemplateName: string;
    setNewTemplateName: (name: string) => void;
    saveAsTemplate: (name: string) => Promise<void>;
    saveAsTemplateAndupdateScheduleFromTemplate: (name: string) => Promise<void>;
}

export const NewTemplateModal: React.FC<INewTemplateModalProps> = ({
    newTemplateModalVisible,
    setNewTemplateModalVisible,
    newTemplateName,
    setNewTemplateName,
    saveAsTemplate,
    saveAsTemplateAndupdateScheduleFromTemplate,
}) => {
    return (
        <Modal
            open={newTemplateModalVisible}
            title="Создание нового шаблона"
            onCancel={() => setNewTemplateModalVisible(false)}
            footer={
                <Space style={{ width: '100%' }} direction="vertical" align="center">
                    <Space>
                        <Button
                            style={{ borderRadius: '8px' }}
                            danger
                            type="primary"
                            onClick={() => setNewTemplateModalVisible(false)}
                        >
                            Отменить
                        </Button>
                        <Button
                            type="primary"
                            onClick={async () => {
                                await saveAsTemplate(newTemplateName);
                                setNewTemplateModalVisible(false);
                            }}
                            style={{ borderRadius: '8px' }}
                        >
                            Сохранить как шаблон
                        </Button>
                    </Space>
                    <Button
                        style={{ background: 'rgb(95, 166, 54)', borderRadius: '8px' }}
                        type="primary"
                        onClick={async () => {
                            await saveAsTemplateAndupdateScheduleFromTemplate(newTemplateName);
                            setNewTemplateModalVisible(false);
                        }}
                    >
                        Сохранить как шаблон и добавить сотруднику
                    </Button>
                </Space>
            }
        >
            <Input value={newTemplateName} onChange={(e) => setNewTemplateName(e.target.value)} />
        </Modal>
    );
};
